/**
 * Kênh sự kiện của người đang đăng nhập (`GET /api/v1/users/me/events`).
 *
 * Dữ liệu mẫu không có kênh: không có máy chủ nào đẩy sự kiện, nên `theoDoi`
 * trả hàm đóng rỗng và các màn sống bằng cơ chế tải lại định kỳ như cũ.
 */
import { dungApiThat } from '../api/http';
import { moKenhSuKien } from '../api/su-kien';
import type { TuyChonKenh } from '../api/su-kien';

export type { SuKienNguoiDung, TrangThaiKenh } from '../api/su-kien';

export const suKienRepository = {
  /** Mở kênh nếu đang dùng API thật; trả hàm đóng. */
  theoDoi(tuyChon: TuyChonKenh): (() => void) | null {
    if (!dungApiThat()) return null;
    return moKenhSuKien(tuyChon);
  },
};
